<div class="modal">
  <button class="close-btn btn" (click)="closeModal()">
    <svg class="icon">
      <use xlink:href="#large-cross"></use>
    </svg>
  </button>

  <div class="head">
    <h3 class="title">
      {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.TITLE' | translate }}
    </h3>
    <p class="subtitle">
      {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.SUBTITLE' | translate }}
    </p>
  </div>

  <app-scrollbar class="scrollbar" [vertical]="true" [size]="'standard'" [visibility]="'native'">
    <div [formGroup]="formGroup" class="content">
      <div class="section">
        <h4 class="title">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.PROFILE_VIEWS' | translate }}
        </h4>

        <p class="subtitle">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.PROFILE_VIEWS_DESC' | translate }}
        </p>

        <app-number-input2
          [minimum]="limits.PROFILE_VIEWS_MIN"
          [maximum]="limits.PROFILE_VIEWS_MAX"
          class="number"
          formControlName="views"></app-number-input2>
      </div>

      <div class="section">
        <h4 class="title">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.LIKES' | translate }}
        </h4>

        <p class="subtitle">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.LIKES_DESC' | translate }}
        </p>

        <app-number-input2
          [minimum]="limits.LIKES_MIN"
          [maximum]="limits.LIKES_MAX"
          class="number"
          formControlName="likes"></app-number-input2>
      </div>

      <div class="section">
        <h4 class="title">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.CONNECTION_REQUESTS' | translate }}
        </h4>

        <p class="subtitle">
          {{
            'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.CONNECTION_REQUESTS_DESC' | translate
          }}
        </p>

        <app-number-input2
          [minimum]="limits.CONNECTION_REQUESTS_MIN"
          [maximum]="limits.CONNECTION_REQUESTS_MAX"
          class="number"
          formControlName="requests"></app-number-input2>
      </div>

      <div class="section">
        <h4 class="title">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.MESSAGES' | translate }}
        </h4>

        <p class="subtitle">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.MESSAGES_DESC' | translate }}
        </p>

        <app-number-input2
          [minimum]="limits.MESSAGES_MIN"
          [maximum]="limits.MESSAGES_MAX"
          class="number"
          formControlName="messages"></app-number-input2>
      </div>

      <div class="section">
        <h4 class="title">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.IN_MAIL' | translate }}
        </h4>

        <p class="subtitle">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.IN_MAIL_DESC' | translate }}
        </p>

        <app-number-input2
          [minimum]="limits.IN_MAIL_MIN"
          [maximum]="limits.IN_MAIL_MAX"
          class="number"
          formControlName="inMail"></app-number-input2>
      </div>

      <div class="section">
        <h4 class="title">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.WITHDRAW_LIMIT' | translate }}
        </h4>

        <p class="subtitle">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.LIMITS_MODAL.WITHDRAW_LIMIT_DESC' | translate }}
        </p>

        <app-number-input2
          [minimum]="limits.WITHDRAW_LIMIT_MIN"
          [maximum]="limits.WITHDRAW_LIMIT_MAX"
          class="number"
          formControlName="withdrawLimit"></app-number-input2>
      </div>
    </div>
  </app-scrollbar>

  <div class="actions">
    <button class="link new-link--back" (click)="closeModal()">
      {{ 'GENERAL.CANCEL' | translate }}
    </button>

    <button
      class="btn btn--new-primary bright save-btn"
      disabled="true"
      [disabled]="saveDisabledSubject | async"
      (click)="save()">
      <span class="btn__text">{{ 'GENERAL.SAVE' | translate }}</span>
    </button>
  </div>
</div>
